import React from 'react';
import { Box, Tab } from '@mui/material';
import { TabPanel } from '@mui/lab';
import useTabStyles from '../../../../../Components/GeneralTabAndTabContent/styles';
import PageLevelScriptConfig from './PageLevelScriptConfig';
import PageLevelVideoConfig from './PageLevelVideoConfig';
import { PageLevelVideoConfigContextProvider } from '../../../../../Contexts/PageLevelVideoConfigContext';
import { PageLevelScriptConfigProvider } from '../../../../../Contexts/PageLevelScriptConfigContext';
import { PAGE_MODES_FOR_PAGE_SETTINGS_TABS } from '../../../../../core/constants';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';

const PageLevelSettings = () => {
	const tabStyleClasses = useTabStyles();

	const tabListAndPanels = [
		{
			tab: (
				<Tab
					sx={{ fontSize: '1.2rem' }}
					label="Page Level Config Settings"
					value={PAGE_MODES_FOR_PAGE_SETTINGS_TABS.PAGE_LEVEL_SCRIPT_CONFIG}
				/>
			),
			tabPanel: (
				<TabPanel
					value={PAGE_MODES_FOR_PAGE_SETTINGS_TABS.PAGE_LEVEL_SCRIPT_CONFIG}
					className={tabStyleClasses.tabPanel}
				>
					<PageLevelScriptConfigProvider>
						<PageLevelScriptConfig />
					</PageLevelScriptConfigProvider>
				</TabPanel>
			)
		},
		{
			tab: (
				<Tab
					sx={{ fontSize: '1.2rem' }}
					label="Page Level Videos Settings"
					value={PAGE_MODES_FOR_PAGE_SETTINGS_TABS.PAGE_PLAYLIST_CONFIG}
				/>
			),
			tabPanel: (
				<TabPanel
					value={PAGE_MODES_FOR_PAGE_SETTINGS_TABS.PAGE_PLAYLIST_CONFIG}
					className={tabStyleClasses.tabPanel}
				>
					<PageLevelVideoConfigContextProvider>
						<PageLevelVideoConfig />
					</PageLevelVideoConfigContextProvider>
				</TabPanel>
			)
		}
	];

	return (
		<Box className={tabStyleClasses.tabContainer}>
			<GeneralTab
				tabListAndPanels={tabListAndPanels}
				tabListStyles={{ width: 'fit-content', marginLeft: '3rem' }}
			/>
		</Box>
	);
};

export default PageLevelSettings;
